
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.281 22.462l-12-10C25.994 11.395 24 12.287 24 14v20c0 1.712 1.994 2.612 3.281 1.538l12-10c.956-.8.956-2.276 0-3.076zm-16 0l-12-10C9.994 11.395 8 12.287 8 14v20c0 1.712 1.994 2.612 3.281 1.538l12-10c.957-.8.957-2.276 0-3.076z","fill":"#535353"}})])
          )
        }
      }
    